'use strict';

import React from 'react'

import Loader from '@Pure/Loader'

import Modal  from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'

import { handleChange } from '@/Form/Functions/eventsHandling'

let app = window.app;

export default class TicketTrackingModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: { },
			form_data: { },
			status_messages: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.validate    = this.validate.bind(this);
		this.open        = this.open.bind(this);

		this.handleChange = handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'open__TicketTrackingModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'open__TicketTrackingModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.state.form_data['tracking'] = '';

		component.setState(
		{
			open: false,
			loading: false,
			form_data: component.state.form_data
		});
	}

	open (ticket)
	{
		const component = this, props = this.props;

		let ticket_infos = ticket.product.tickets[ticket.ticket_id] || { };

		if (ticket_infos.tracking)
		{
			component.state.form_data['tracking'] = ticket_infos.tracking;
		}

		component.setState(
		{
			open : true,
			data: ticket,
			form_data: component.state.form_data
		});
	}

	validate (e)
	{
		const component = this, props = this.props;

		component.setState(
		{
			loading: true
		});

		qwest.post('/order/update-tracking',
		{
			ticket_id: component.state.data.ticket_id,
			order_id: component.state.data.order.id,
			ref: component.state.data.product.price.ref,
			tracking: component.state.form_data['tracking']
		})
		.then(function (xhr, response)
		{
			app.emit('changedTicketTracking',
			{
				ticket: component.state.data,
				tracking: component.state.form_data['tracking']
			});

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let output =
		(
			<Modal open={ component.state.open } onClose={ component.handleClose }
				title="Saisie d'un numéro de suivi" hide_close={ true }>

				<FormElement name="tracking" type="text" data={ state.form_data }
					onChange={ component.handleChange } label="Numéro de suivi"
					status={ state.status_messages }/>

				<div className="c-dialog__buttons">
					<button className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Annuler
					</button>

					<button className="c-btn c-dialog__danger"
						onClick={ component.validate }>
						Valider
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
